var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDelete2 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 25 25"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 19308"
}, /*#__PURE__*/React.createElement("g", {
  fill: "none",
  "data-name": "Group 19284"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h25v25H0z",
  "data-name": "Rectangle 2366"
}), /*#__PURE__*/React.createElement("g", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  "data-name": "Group 9155"
}, /*#__PURE__*/React.createElement("path", {
  d: "M19.813 7.068a86 86 0 0 0-8.5-.424 50 50 0 0 0-5.038.254l-1.73.17",
  "data-name": "Path 1587"
}), /*#__PURE__*/React.createElement("path", {
  d: "m9.21 6.215.187-1.111c.135-.808.237-1.408 1.671-1.408h2.222c1.434 0 1.544.636 1.671 1.417l.187 1.1",
  "data-name": "Path 1588"
}), /*#__PURE__*/React.createElement("path", {
  d: "m17.989 9.753-.551 8.542c-.093 1.332-.17 2.367-2.536 2.367H9.456c-2.367 0-2.443-1.035-2.536-2.367l-.552-8.542",
  "data-name": "Path 1589"
}))))));
export { SvgDelete2 as ReactComponent };
export default __webpack_public_path__ + "static/media/delete2.19caf11d93ee53a29585b1b452dc789d.svg";